import React, { useState, useEffect } from 'react'

import { IUIButtonProps } from '@ui/buttons/Button'

import api, { IUsageType } from '@api'
import { bookableDesks } from '@utils/space'

import { formatSelectItems } from 'components/SpaceAssets'
import EvoSelect from '../EvoSelect'

interface UsageTypeSelectProps {
  value?: IUsageType | null
  onChange: (usageType: IUsageType) => void
  buttonProps?: IUIButtonProps
  btnText?: string
  itemDisabled?: (usageType: IUsageType) => boolean
  multi?: boolean
  bookableOnly?: boolean
  allOptionEnable?: boolean
  filterable?: boolean
}

const bookableTypes = new Set(bookableDesks)

export default function UsageTypeEvoSelect({
  value,
  onChange,
  bookableOnly,
}: UsageTypeSelectProps) {
  const usageTypes = useUsageTypes(bookableOnly)

  const formatItems = (list: any[] | undefined) => {
    const formattedItems: any = list?.map((item: any) => {
      return {
        label: item?.displayName,
        value: item?.id,
        name: item?.name,
      }
    })
    return formattedItems
  }

  return (
    <EvoSelect
      isSearchable
      options={formatItems(usageTypes)}
      value={
        value?.id
          ? { label: value?.displayName, value: value?.id }
          : { label: usageTypes[0]?.displayName, value: usageTypes[0]?.id }
      }
      onChange={(usageType: any) => {
        onChange({
          id: usageType.value,
          name: usageType.name,
          displayName: usageType.label,
        })
      }}
      size="small"
    />
  )
}

let persistedState: IUsageType[] = []

export function useUsageTypes(bookableOnly?: boolean): IUsageType[] {
  const [usageTypes, setUsageTypes] = useState<IUsageType[]>(persistedState)

  useEffect(() => {
    query(bookableOnly)
  }, [bookableOnly])

  useEffect(() => {
    // Cache initial list
    if (!persistedState.length && usageTypes.length) {
      persistedState = usageTypes
    }
  }, [usageTypes])

  const query = (bookableOnly?: boolean) =>
    api.company.usageTypes().then((usageTypes) => {
      if (bookableOnly) {
        setUsageTypes(usageTypes.filter((ut) => bookableTypes.has(ut.name)))
      } else {
        setUsageTypes(usageTypes)
      }
    })

  return usageTypes
}
